export default function Process() {
  const steps = [
    {
      number: '01',
      title: 'Recon',
      description: 'Deep-dive on current ops, identify failure points',
      icon: 'ri-search-eye-line'
    },
    {
      number: '02',
      title: 'Assessment',
      description: 'Map bottlenecks and second-order risks',
      icon: 'ri-radar-line'
    },
    {
      number: '03',
      title: 'Deployment',
      description: 'Implement systems, dashboards, communication cadences',
      icon: 'ri-rocket-line'
    },
    {
      number: '04',
      title: 'Optimization',
      description: 'Test, iterate, scale with measurable improvements',
      icon: 'ri-speed-up-line'
    }
  ];

  return (
    <section id="process" className="py-32 px-6 bg-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold mb-6">
            <strong>Process</strong>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            A systematic approach to operational transformation
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-cyan-500/50 to-transparent"></div>
              )}
              
              <div className="relative bg-zinc-900/50 border border-zinc-800 p-8 rounded-lg hover:border-cyan-500/50 transition-all duration-300 group cursor-pointer">
                <div className="absolute -top-4 -left-4 w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center font-bold text-black text-sm">
                  {step.number}
                </div>
                
                <div className="w-16 h-16 flex items-center justify-center bg-cyan-500/10 rounded-lg mb-6 mt-4 group-hover:bg-cyan-500/20 transition-colors">
                  <i className={`${step.icon} text-4xl text-cyan-400`}></i>
                </div>
                
                <h3 className="text-2xl font-bold mb-4 group-hover:text-cyan-400 transition-colors">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
